var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M16.462 20.505L7.86 12.058l8.602-8.446","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

ChevronLeftInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
